import React from "react";
import ManufacturedDevices from "../../device/ManufacturedDevices";
import ResponsiveContentWrapper from "../../layout/ResponsiveContentWrapper";

const ManufacturedDevicesPage = ({ wrapperClass = "" }) => {
  return (
    <ResponsiveContentWrapper className={`content-wrapper ${wrapperClass}`.trim()}>
      <ManufacturedDevices />
    </ResponsiveContentWrapper>
  );
};

export default ManufacturedDevicesPage;
